import styled from 'styled-components'

export const StyledNewsStartDateSelect = styled.div`
  .startDateSelect {
    width: 320px;
  }
`
